__turbopack_context__.v({
  "circle": "style-module-scss-module__hyLhaa__circle",
  "content": "style-module-scss-module__hyLhaa__content",
  "curvedContainer": "style-module-scss-module__hyLhaa__curvedContainer",
  "curvedText": "style-module-scss-module__hyLhaa__curvedText",
  "curvedWrapper": "style-module-scss-module__hyLhaa__curvedWrapper",
  "tableWrapper": "style-module-scss-module__hyLhaa__tableWrapper",
  "titleGraffiti": "style-module-scss-module__hyLhaa__titleGraffiti",
  "video": "style-module-scss-module__hyLhaa__video",
  "videoLeft": "style-module-scss-module__hyLhaa__videoLeft",
  "videoRight": "style-module-scss-module__hyLhaa__videoRight",
  "wrapper": "style-module-scss-module__hyLhaa__wrapper",
});
